import { useQuery } from '@tanstack/react-query'

import { getRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'

interface OnboardingStatusResponse {
  authProvider: string | null
  hasEmail: boolean
  emailVerified: boolean
  hasPhone: boolean
  phoneVerified: boolean
  email: string | null
  phoneNumber: string | null
  firstName: string | null
  lastName: string | null
  needsEmail: boolean
  needsPhone: boolean
  needsEmailVerification: boolean
  needsPhoneVerification: boolean
  userExists: boolean
  onboardingComplete: boolean
}

export async function getOnboardingStatus() {
  const result = await getRequest<OnboardingStatusResponse>('/auth/onboarding-status')
  return result
}

export const useOnboardingStatus = () => {
  return useQuery({
    queryKey: queries.auth.onboardingStatus.queryKey,
    queryFn: async () => {
      const result = await getOnboardingStatus()
      return result
    },
  })
}
